import React, { useEffect } from 'react';
import { useEditor, EditorContent, useEditorState } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import { Bold, Italic, List, ListOrdered } from 'lucide-react';

const TOOLS = [
  { key: 'bold', icon: Bold, label: 'Bold', run: c => c.toggleBold() },
  { key: 'italic', icon: Italic, label: 'Italic', run: c => c.toggleItalic() },
  { key: 'bulletList', icon: List, label: 'Bullet list', run: c => c.toggleBulletList() },
  { key: 'orderedList', icon: ListOrdered, label: 'Numbered list', run: c => c.toggleOrderedList() },
];

export const RichTextEditor = ({ value, onChange, testId, minHeight = 110 }) => {
  const editor = useEditor({
    extensions: [StarterKit.configure({ heading: false, codeBlock: false, blockquote: false, code: false, horizontalRule: false, strike: false, link: false })],
    content: value || '',
    onUpdate: ({ editor: e }) => onChange(e.isEmpty ? '' : e.getHTML()),
    editorProps: { attributes: { class: 'rich-content focus:outline-none px-3 py-2 text-sm text-white', style: `min-height:${minHeight}px`, 'data-testid': `${testId}-input` } },
  });
  const active = useEditorState({ editor, selector: ({ editor: e }) => Object.fromEntries(TOOLS.map(t => [t.key, !!e?.isActive(t.key)])) }) || {};

  useEffect(() => {
    if (editor && value !== (editor.isEmpty ? '' : editor.getHTML())) editor.commands.setContent(value || '', { emitUpdate: false });
  }, [value, editor]);

  return (
    <div data-testid={testId} className="rounded-md border border-slate-700 bg-[#080d18] focus-within:border-cyan-400 transition-colors">
      <div className="flex items-center gap-1 border-b border-slate-800 px-1.5 py-1">
        {TOOLS.map(({ key, icon: Icon, label, run }) => (
          <button key={key} type="button" title={label} aria-label={label} data-testid={`${testId}-${key}-btn`}
            onMouseDown={e => { e.preventDefault(); if (editor) run(editor.chain().focus()).run(); }}
            className={`h-7 w-7 inline-flex items-center justify-center rounded transition-colors ${active[key] ? 'bg-cyan-400/20 text-cyan-300' : 'text-slate-400 hover:bg-slate-800 hover:text-white'}`}>
            <Icon className="w-3.5 h-3.5" />
          </button>
        ))}
      </div>
      <EditorContent editor={editor} />
    </div>
  );
};

export default RichTextEditor;
